import React, { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import Attachments from "../../Pages/Submitter/Attachments";
import FindOutAwardPage from "../../Pages/Submitter/Attachments/FindOutAwardPage";
import PledgeAndAcknowledgement from "../../Pages/Submitter/Attachments/PledgeAndAcknowledgement";
import ButtonAHSF from "../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import $ from "jquery";
import {
  ChangeApplicationStatus,
  SubmitApplication,
} from "../../Redux/Reducers/Shared/ApplicationInformation";
import { useDispatch, useSelector } from "react-redux";
import { ValidationAllPages } from "../../Redux/Reducers/Submitter/ValidateAllPages";
import PopupAHSF from "../../Components/PopupAHSF";
import { useLocation } from "react-router-dom";
import { decryptToken } from "../../Services/Encryption/EncryptionParams";

const AttachmentsContainer = () => {
  const [ShowButtonEdit, setShowButtonEdit] = useState(false);
  const location = useLocation();
  // استخراج GUID باستخدام Regular Expression
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/");
  console.log(encryptedToken, "slkdslkdlksdl");
  var guid =
    encryptedToken[encryptedToken.length - 1] != null
      ? decryptToken(encryptedToken[encryptedToken.length - 1])
      : null;
  const dispatch = useDispatch();
  const [ShowFeild, setShowFeild] = useState(false);
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  const state = useSelector((state) => {
    return {
      MainResearcherInformation:
        state.MainResearcherInformation.MainResearcherInformain,
      InfoScientificFoundation:
        state.InformationAboutScientificInstitution.InfoScientificFoundation,
      jsonData: state.FetchDataJson.JsonData,
      ValidateAllPages: state.ValidateAllPages.ValidateAllPages,
    };
  });
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);

  // State to prevent multiple form submissions
  const [isSubmitting, setIsSubmitting] = useState(false);
  console.log(state.ValidateAllPages, "jhjhjhjhjhjhjhjhjhjh");

  // Function to save data and handle validations
  const SaveDataPage = async (withValidate) => {
    if (isSubmitting) return; // Prevent multiple submissions
    setIsSubmitting(true); // Mark submission in progress

    const validate = await dispatch(
      ValidationAllPages(localStorage.getItem("ApplicationInformationId"))
    );
    console.log(validate.payload, "validate.payload");
    if (validate.payload) {
      if (Object.keys(validate.payload).length === 0) {
        // If validation passes
        const updated = await dispatch(
          SubmitApplication({
            applicationInformationId: localStorage.getItem(
              "ApplicationInformationId"
            ),
          })
        );

        if (updated.payload) {
          // If status update succeeds

          Swal.fire({
            // Display success message
            position: "center",
            icon: "success",
            title: "تم تقديم طلبك بنجاح",
            showConfirmButton: false,
            timer: 2000, // Auto-close after 2 seconds
          }).then(() => {
            window.location.replace("/SRFund/mainpage"); // Redirect to main page
          });
        }
      } else {
        setisPopupOpenStatus(true); // Show validation errors popup
      }
    }
    setIsSubmitting(false); // Reset submission state
  };

  // Function to save data and handle validations
  const SaveEditDataPage = async (withValidate) => {
    if (isSubmitting) return; // Prevent multiple submissions
    setIsSubmitting(true); // Mark submission in progress

    const validate = await dispatch(
      ValidationAllPages(localStorage.getItem("ApplicationInformationId"))
    );
    console.log(validate.payload, "validate.payload");
    if (validate.payload) {
      if (Object.keys(validate.payload).length === 0) {
        // If validation passes
        const updated = await dispatch(
          ChangeApplicationStatus({
            applicationInfoId: localStorage.getItem("ApplicationInformationId"),
            statusId: "521bf595-b593-4551-a2b6-8fb3719314de",
          })
        );

        if (updated.payload) {
          // If status update succeeds

          Swal.fire({
            // Display success message
            position: "center",
            icon: "success",
            title: "تم تعديل طلبك بنجاح",
            showConfirmButton: false,
            timer: 2000, // Auto-close after 2 seconds
          }).then(() => {
            window.location.replace("/SRFund/mainpage"); // Redirect to main page
          });
        }
      } else {
        setisPopupOpenStatus(true); // Show validation errors popup
      }
    }
    setIsSubmitting(false); // Reset submission state
  };

  const shouldDisableFields = !(

    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.applicationStatusId == "57ca8392-5b8e-4625-8a37-00dfc27d5b28" ? true :
      ActiveRound == ApplicationInformation?.aI_RoundYearId &&
      ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
      window.location.href.includes("manager") == false
  );

  console.log(ApplicationInformation?.aI_RoundYearId, "sdsddwwwwdwd");

  useEffect(() => {
    if (
      ApplicationInformation?.applicationStatusId ===
      "ea0300ee-f64d-441e-ad47-f2a2b9adf293"
    ) {
      setShowFeild(true);
    } else if (
      ApplicationInformation?.applicationStatusId ===
      "57ca8392-5b8e-4625-8a37-00dfc27d5b28"
    ) {
      setShowButtonEdit(true);
    } else {
      setShowFeild(false);
      setShowButtonEdit(false);
    }
  }, [ApplicationInformation]);

  return (
    <>
      <Attachments
        applicationGuid={guid}
        shouldDisableFields={shouldDisableFields}
      />

      <FindOutAwardPage
        applicationGuid={guid}
        shouldDisableFields={shouldDisableFields}
      />

      <PledgeAndAcknowledgement
        applicationGuid={guid}
        shouldDisableFields={shouldDisableFields}
      />
      {!shouldDisableFields ? (
        <>
          <div className="containerButtonMAin">
            {/* Render Save button */}
            <ButtonAHSF
              type={"submitter"}
              onClick={() => {
                SaveDataPage(true);
              }}
              disabled={false}
              title={"تقديم"}
              text={"تقديم"}
              show={true}
            />
            {/* Render Next button */}
          </div>
        </>
      ) : (
        <></>
      )}

      {ShowButtonEdit && window.location.href.includes("manager") == false ? (
        <>
          <div className="containerButtonMAin">
            <ButtonAHSF
              type={"submitter"}
              onClick={() => {
                SaveEditDataPage(true);
              }}
              disabled={false}
              title={"تعديل"}
              text={"تعديل"}
              show={true}
            />
          </div>
        </>
      ) : (
        <></>
      )}

      {/* Popup for validation errors */}
      {state.ValidateAllPages ? (
        <PopupAHSF
          isPopupOpenStatus={isPopupOpenStatus} // Popup visibility state
          isPopupOpenFunction={() => setisPopupOpenStatus(false)} // Function to close popup
          forValidateAllPages={true} // Indicates the popup is for page validation
          maxWidth="50%" // Popup width
          title="يرجى تعبئة الحقول المطلوبة" // Popup title
          componentBody={state.ValidateAllPages} // Validation errors content
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default AttachmentsContainer;
